export default {
  Actions: {
    CREATE_FEEDBACK_COMMENT_REQUEST: 'feedbacks/CREATE_FEEDBACK_COMMENT_REQUEST',
    CREATE_FEEDBACK_COMMENT_SUCCESS: 'feedbacks/CREATE_FEEDBACK_COMMENT_SUCCESS',
    CREATE_FEEDBACK_COMMENT_FAILURE: 'feedbacks/CREATE_FEEDBACK_COMMENT_SUCCESS',
    UPDATE_FEEDBACK_COMMENT_REQUEST: 'feedbacks/UPDATE_FEEDBACK_COMMENT_REQUEST',
    UPDATE_FEEDBACK_COMMENT_SUCCESS: 'feedbacks/UPDATE_FEEDBACK_COMMENT_SUCCESS',
    UPDATE_FEEDBACK_COMMENT_FAILURE: 'feedbacks/UPDATE_FEEDBACK_COMMENT_SUCCESS',
    DESTROY_FEEDBACK_COMMENT_REQUEST: 'feedbacks/DESTROY_FEEDBACK_COMMENT_REQUEST',
    DESTROY_FEEDBACK_COMMENT_FAILURE: 'feedbacks/DESTROY_FEEDBACK_COMMENT_FAILURE',
    VIEW_FEEDBACK_COMMENT_SUCCESS: 'feedback/VIEW_FEEDBACK_COMMENT_SUCCESS',
  },
};
